import { render, staticRenderFns } from "./EtoroTrades.vue?vue&type=template&id=28c56506&scoped=true"
import script from "./EtoroTrades.vue?vue&type=script&lang=js"
export * from "./EtoroTrades.vue?vue&type=script&lang=js"
import style0 from "./EtoroTrades.vue?vue&type=style&index=0&id=28c56506&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c56506",
  null
  
)

export default component.exports